import { Link } from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ToolCardProps {
  title: string
  description: string
  href: string
  icon: LucideIcon
  formats: readonly string[]
  className?: string
}

/** Bento-style entry card for a tool, used on the home page grid. */
export function ToolCard({ title, description, href, icon: Icon, formats, className }: ToolCardProps) {
  return (
    <Link
      to={href}
      className={cn(
        'group flex flex-col justify-between rounded-2xl border bg-card p-6 shadow-sm transition-all duration-150 ease-out hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-md',
        className,
      )}
    >
      <div className="space-y-4">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Icon className="h-6 w-6" aria-hidden />
        </span>
        <div className="space-y-1">
          <h3 className="flex items-center gap-1 text-lg font-semibold">
            {title}
            <ArrowUpRight
              className="h-4 w-4 text-muted-foreground transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-primary"
              aria-hidden
            />
          </h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-1.5">
        {formats.map((format) => (
          <span
            key={format}
            className="rounded-md bg-muted px-1.5 py-0.5 font-mono text-xs text-muted-foreground"
          >
            {format}
          </span>
        ))}
      </div>
    </Link>
  )
}
